import { initContract } from '@ts-rest/core'
import z from 'zod'
import { ErrorResponseSchema } from '../../shared/types'
import {
  ListOrderRescheduleReasonsResponseSchema,
  OrderRescheduleReasonSchema,
  QueryOrderRescheduleReasonsQuerySchema,
  RecordOrderRescheduleReasonBodySchema,
} from './schemas'

const c = initContract()

const options = {
  pathPrefix: '/api/v1',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

/**
 * Tracks why orders were moved off a delivery date (e.g. public holiday shifts).
 * Mirrors Laravel's delivery_reschedule_reasons_orders for CC visibility and email workflows.
 */
export const orderRescheduleReasonsContract = c.router(
  {
    recordOrderRescheduleReason: {
      method: 'POST',
      description: 'Record that an order was rescheduled, with the reason and before/after delivery dates. Returns 404 if the order does not exist.',
      path: '/orders/reschedule-reasons',
      body: RecordOrderRescheduleReasonBodySchema,
      responses: {
        201: OrderRescheduleReasonSchema,
        404: ErrorResponseSchema,
      },
    },

    queryOrderRescheduleReasons: {
      method: 'GET',
      description: 'Query reschedule records by userId, reasonRefId (operational block id), or previousDeliveryDate. reasonType optionally narrows reasonRefId/previousDeliveryDate queries. reasonRefId may be combined with previousDeliveryDate and reasonType. Returns an empty list when no filter is provided. Filters are mutually exclusive: userId takes precedence, then reasonRefId, then previousDeliveryDate.',
      path: '/orders/reschedule-reasons',
      query: QueryOrderRescheduleReasonsQuerySchema,
      responses: {
        200: ListOrderRescheduleReasonsResponseSchema,
      },
    },

    listOrderRescheduleReasonsByOrder: {
      method: 'GET',
      description: 'Return all reschedule records for an order, newest first.',
      path: '/orders/reschedule-reasons/order/:orderId',
      pathParams: z.object({ orderId: z.string().uuid() }),
      responses: {
        200: ListOrderRescheduleReasonsResponseSchema,
      },
    },
  },
  options,
)
